import { initializeApp } from 'firebase/app';
import {
  connectFunctionsEmulator,
  getFunctions,
  httpsCallable,
} from 'firebase/functions';
import { initializeAppCheck, ReCaptchaV3Provider } from 'firebase/app-check';

const {
  REACT_APP_ENTORNO_BIENIMED_BACK,
  REACT_APP_ENTORNO_BIENI_BACK,
  REACT_APP_ENTORNO_BACK_FOR_FRONT,
  REACT_APP_LIVEKIT_URL,
  REACT_APP_FRONTMANAGER_URL,
  REACT_APP_FUNCTIONS_EMULATOR_HOST,
  REACT_APP_FUNCTIONS_EMULATOR_PORT,
  REACT_APP_API_KEY,
  REACT_APP_AUTH_DOMAIN,
  REACT_APP_PROJECT_ID,
  REACT_APP_STORAGE_BUCKET,
  REACT_APP_MESSAGING_SENDER_ID,
  REACT_APP_APP_ID,
  REACT_APP_MEASUREMENT_ID,
  REACT_APP_RECAPTCHA_KEY,
  REACT_APP_ENTORNO_DEV,
  REACT_APP_FIREBASE_FUNCTIONS_HOST,
  REACT_APP_FIREBASE_FUNCTIONS_PORT,
  REACT_APP_ENTORNO_FRONTEND,
} = process.env;

const REACT_APP_COMPONENT_CONSOLE =
  process.env.REACT_APP_COMPONENT_CONSOLE ?? 'disabled';

export const envVar = {
  REACT_APP_ENTORNO_BIENIMED_BACK,
  REACT_APP_ENTORNO_BIENI_BACK,
  REACT_APP_ENTORNO_BACK_FOR_FRONT,
  REACT_APP_LIVEKIT_URL,
  REACT_APP_FRONTMANAGER_URL,
  REACT_APP_FUNCTIONS_EMULATOR_HOST,
  REACT_APP_FUNCTIONS_EMULATOR_PORT,
  REACT_APP_API_KEY,
  REACT_APP_AUTH_DOMAIN,
  REACT_APP_PROJECT_ID,
  REACT_APP_STORAGE_BUCKET,
  REACT_APP_MESSAGING_SENDER_ID,
  REACT_APP_APP_ID,
  REACT_APP_MEASUREMENT_ID,
  REACT_APP_RECAPTCHA_KEY,
  REACT_APP_ENTORNO_DEV,
  REACT_APP_FIREBASE_FUNCTIONS_HOST,
  REACT_APP_FIREBASE_FUNCTIONS_PORT,
  REACT_APP_ENTORNO_FRONTEND,
  REACT_APP_COMPONENT_CONSOLE,
};

const firebaseConfig = {
  apiKey: envVar.REACT_APP_API_KEY,
  authDomain: envVar.REACT_APP_AUTH_DOMAIN,
  projectId: envVar.REACT_APP_PROJECT_ID,
  storageBucket: envVar.REACT_APP_STORAGE_BUCKET,
  messagingSenderId: envVar.REACT_APP_MESSAGING_SENDER_ID,
  appId: envVar.REACT_APP_APP_ID,
  measurementId: envVar.REACT_APP_MEASUREMENT_ID,
};

const app = initializeApp(firebaseConfig);

const isLocalDev = envVar.REACT_APP_ENTORNO_DEV === 'true';

if (!isLocalDev) {
  initializeAppCheck(app, {
    provider: new ReCaptchaV3Provider(envVar.REACT_APP_RECAPTCHA_KEY),
    isTokenAutoRefreshEnabled: true,
  });
}

const functionsImport = getFunctions(
  app,
  'us-central1',
  envVar.REACT_APP_PROJECT_ID
);

if (isLocalDev) {
  connectFunctionsEmulator(
    functionsImport,
    envVar.REACT_APP_FIREBASE_FUNCTIONS_HOST || '127.0.0.1',
    Number(envVar.REACT_APP_FIREBASE_FUNCTIONS_PORT || 5001)
  );
}

export const generarTokenCifrado = httpsCallable(
  functionsImport,
  'generarTokenCifrado'
);
